<template>
  <v-app :class="classes" fill-height>
    <v-navigation-drawer app v-model="drawer"
      :temporary="true"
      v-if="appStep === 3" :key="viewUpdate + 1" >
      <v-toolbar flat class="nav-drawer-user-panel" v-if="userObject" @click="$router.push('/home')">
        <v-list dark class="transparent">
          <v-list-tile class="avatar-tile">
            <v-list-tile-avatar size="64">
              <img src="@/assets/images/icon-asdetect-480x480.png" >
            </v-list-tile-avatar>
          </v-list-tile>
          <v-list-tile class="name-tile">
            <v-list-tile-content>
              <v-list-tile-title>
              {{ `${userObject.firstName} ${userObject.lastName}` }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      <v-divider v-if="userObject"></v-divider>
      <v-list dense class="pt-0">
        <v-list-tile v-for="item in navMenuItems" :key="item.title" @click="item.action">
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ $t(item.title) }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar app dark color="primary" class="header-toolbar"
      v-if="appStep === 3" :key="viewUpdate + 2">
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title v-html="appToolbarTitle"></v-toolbar-title>
    </v-toolbar>

    <v-content fill-height :key="viewUpdate">
      <v-container fluid fill-height pa-0>
        <router-view></router-view>
      </v-container>
    </v-content>

    <v-snackbar :timeout="snackbarConfig.timeout" :color="snackbarConfig.color" v-model="snackbar" :key="viewUpdate + 3">
      {{ snackbarConfig.text }}
      <v-btn dark flat @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>

    <bootstrap-dialog :show.sync="addBootstrapDialog"></bootstrap-dialog>
  </v-app>
</template>

<script>
import '@/styles/main.scss' // add the scss contents to output html/css files

import Vue from 'vue'
import theme from 'vuetify/es5/components/Vuetify/mixins/theme'

import {
  mapState,
  mapGetters,
  mapActions,
  mapMutations
} from 'vuex'
// import firebaseConfig from '@/firebase'
import {
  UPDATE_APP_INIT,
  DEQUEUE_SNACKBAR,
  ENQUEUE_SNACKBAR,
  UPDATE_ASSESSMENTS,
  REMOVE_USER_LOGIN_INFO,
  UPDATE_AVAILABLE_LANGUAGES
} from '@/store/mutation-types'
import BootstrapDialog from '@/components/dialogs/BootstrapDialog'
import { LANG_THEMES } from '@/constants'

const MENU_VIS = {
  ANYTIME: 0,
  BEFORE_LOGIN: 1,
  AFTER_LOGIN: 2,
  LANG_EN: 11,
  LANG_ES: 12
}

export default {
  name: 'App',
  components: {
    'bootstrap-dialog': BootstrapDialog
  },
  computed: {
    classes: function () {
      const _classes = {
        'step1': this.appStep && this.appStep === 1,
        'step2': this.appStep && this.appStep === 2,
        'step3': this.appStep && this.appStep === 3
      }

      if (this.userLanguage.indexOf('-') > 0) {
        _classes[ `lang-${this.userLanguage.split('-')[0]}` ] = true
      }

      _classes[ `lang-${this.userLanguage}` ] = true

      return _classes
    },
    navMenuItems: function () {
      let items = this.availableMenuItems.slice()

      const userLoggedIn = !!this.userObject

      items = items.filter(item => {
        if (!item.visibleWhen || item.visibleWhen === MENU_VIS.ANYTIME) {
          return true
        }

        if (item.visibleWhen === MENU_VIS.LANG_ES && this.userLanguage === 'es') {
          return true
        }

        return (item.visibleWhen === MENU_VIS.BEFORE_LOGIN && !userLoggedIn) ||
          (item.visibleWhen === MENU_VIS.AFTER_LOGIN && userLoggedIn)
      })

      return items
    },
    ...mapState([
      'appStep',
      'appInit',
      'snackbarQueue',
      'userObject'
    ]),
    ...mapGetters([
      'appToolbarTitle',
      'userLanguage'
    ])
  },
  created () {
    this._handleLanguageChanged()

    this.$store.dispatch('getAssessmentConfig').then(resp => {
      this.initData.assessmentConfigs = resp.data.data
    // this.$firebaseRefs.assessmentConfigs.on('value', snapshot => {
      // this.initData.assessmentConfigs = snapshot.val()
    })

    this.$store.dispatch('getAvailableLanguages').then(resp => {
      const newLangs = resp.data.data
      // this.$firebaseRefs.availableLanguages.on('value', snapshot => {
      // const newLangs = snapshot.val()
      if (newLangs && newLangs.length) {
        this.updateAvailableLanguages(newLangs)
      }
    })

    this.$store.dispatch('getLanguageTranslation').then(resp => {
      const updatedTr = resp.data.data
      this.initData.translations = updatedTr
      // this.$firebaseRefs.translations.on('value', snapshot => {
      //  this.initData.translations = snapshot.val()
      // const updatedTr = snapshot.val()

      // console.log('updated tr trvalue', updatedTr)

      Object.keys(updatedTr).forEach(langCode => {
        this.$i18n.setLocaleMessage(langCode, updatedTr[langCode])
        // console.log('setLocaleMessage', langCode, updatedTr[langCode])
      })

      // force re-render the whole application
      // FIXME not a good way to handle this. Consider to use full page loading animation and redirection
      console.info('updated i18n messages, force update view now')
      this.refreshUILang()
      // this.$forceUpdate()

      if (!this.appInit) {
        Vue.nextTick(() => {
          this.$store.commit(UPDATE_APP_INIT, true)
        })
      }
    })
  },
  data () {
    return {
      drawer: false,
      availableMenuItems: [
        {
          visibleWhen: MENU_VIS.AFTER_LOGIN,
          icon: 'account_box',
          title: 'LBL.LOGOUT',
          action: () => {
            this.logout()
              .then(() => {
                this.showMessage({
                  text: this.$i18n.t('MSG.LOGOUT_SUCCESS'),
                  color: 'success'
                })
                this.$router.push('/start')
              })
              .catch((error) => {
                console.log('api error', error)
                this.showMessage({
                  text: this.$i18n.t('MSG.SYSTEM_ERROR_RETRY'),
                  color: 'error'
                })
              })
          }
        },
        {
          visibleWhen: MENU_VIS.ANYTIME,
          icon: 'info',
          title: 'LBL.ABOUT_ASDETECT',
          action: () => this.$router.push('/aboutus')
        },
        {
          visibleWhen: MENU_VIS.AFTER_LOGIN,
          icon: 'settings',
          title: 'LBL.SETTINGS',
          action: () => this.$router.push('/settings')
        },
        {
          visibleWhen: MENU_VIS.AFTER_LOGIN,
          icon: 'list',
          title: 'LBL.MY_ASSESSMENTS',
          action: () => this.$router.push('/home')
        },
        {
          visibleWhen: MENU_VIS.ANYTIME,
          icon: 'https',
          title: 'LBL.PRIVACY',
          action: () => this.$router.push('/privacy')
        },
        {
          visibleWhen: MENU_VIS.ANYTIME,
          icon: 'email',
          title: 'LBL.CONTACT_US',
          action: () => (window.location.href = 'mailto:ask@asdetect.org')
        },
        {
          visibleWhen: MENU_VIS.ANYTIME,
          icon: 'language',
          title: 'LBL.ASDETECT_ORG',
          action: () => window.open('http://www.asdetect.org', '_blank')
        },
        {
          visibleWhen: MENU_VIS.ANYTIME,
          icon: 'language',
          title: 'LBL.LA_TROBE_UNIVERSITY',
          action: () => window.open('http://www.latrobe.edu.au/', '_blank')
        },
        {
          visibleWhen: MENU_VIS.LANG_ES,
          icon: 'language',
          title: 'LBL.UNIVERSITY_OF_SALAMANCA',
          action: () => window.open('http://www.usal.es/', '_blank')
        },
        {
          visibleWhen: MENU_VIS.AFTER_LOGIN,
          requireLogin: true,
          icon: 'exit_to_app',
          title: 'LBL.SAVE_AND_EXIT',
          action: () => {
            this.logout()
              .then(() => {
                this.showMessage({
                  text: this.$i18n.t('MSG.LOGOUT_SUCCESS'),
                  color: 'success'
                })
                this.$router.push('/start')
              })
              .catch((error) => {
                console.log('api error', error)
                this.showMessage({
                  text: this.$i18n.t('MSG.SYSTEM_ERROR_RETRY'),
                  color: 'error'
                })
              })
          }
        }
      ],
      viewUpdate: 0,
      snackbar: false,
      snackbarConfig: {},
      initData: {
        assessmentConfigs: null,
        translations: null
      },
      addBootstrapDialog: false
    }
  },
  // firebase: {
  //   assessmentConfigs: firebaseConfig.assessmentConfigs,
  //   availableLanguages: firebaseConfig.availableLanguages,
  //   translations: firebaseConfig.translations
  // },
  methods: {
    showNextSnackbar () {
      if (!this.snackbar && this.snackbarQueue.length) {
        const snackbarConfig = this.snackbarQueue[0]
        const onClose = snackbarConfig.onClose || false
        const timeout = snackbarConfig.timeout || 6000

        this.snackbarConfig = snackbarConfig
        this.snackbar = true
        if (this.snackbarConfig.onClose) {
          setTimeout(() => {
            onClose()
          }, timeout)
        }
      }
    },
    refreshUILang () {
      console.log('refreshUILang()')
      this.viewUpdate++
    },
    _handleLanguageChanged () {
      console.log('_handleLanguageChanged:trigger')

      // update Vuetify theme color
      if (LANG_THEMES && LANG_THEMES[this.userLanguage]) {
        console.log('_handleLanguageChanged:updateTheme')
        this.$vuetify.theme = theme(LANG_THEMES[this.userLanguage])
      }
    },
    ...mapActions([
      'logout',
      'refreshUserInfo',
      'refreshChildList'
    ]),
    ...mapMutations({
      showMessage: ENQUEUE_SNACKBAR,
      removeMessage: DEQUEUE_SNACKBAR,
      removeUserLoginInfo: REMOVE_USER_LOGIN_INFO,
      updateAvailableLanguages: UPDATE_AVAILABLE_LANGUAGES
    })
  },
  mounted () {
    this.addBootstrapDialog = true
  },
  watch: {
    $route (to, from) {
      console.log('$route changed', to, from)
    },
    initData: {
      deep: true,
      handler (val) {
        if (val.translations && val.assessmentConfigs) {
          const parsed = {}
          val.assessmentConfigs.forEach((config) => {
            parsed[config.age] = Object.assign({}, config)
          })

          this.$store.commit(UPDATE_ASSESSMENTS, parsed)
        }
      }
    },
    appInit (appInit) {
      if (this.$store.state.userToken) {
        Promise.all([
          this.refreshUserInfo(),
          this.refreshChildList()
        ])
          .catch((error) => {
            let errorMessage = this.$i18n.t('MSG.SYSTEM_ERROR_RETRY')
            if (error.response && error.response.status === 401) {
              errorMessage = this.$i18n.t('MSG.SESSION_EXPIRED')
              this.removeUserLoginInfo()
              this.$router.push('/start')
            }

            this.showMessage({
              text: errorMessage,
              color: 'error'
            })
          })
      }
    },
    snackbarQueue (snackbarQueue) {
      if (snackbarQueue.length) {
        this.showNextSnackbar()
      }
    },
    snackbar (snackbar) {
      if (!snackbar && this.snackbarQueue.length) {
        setTimeout(() => {
          this.removeMessage()
        }, 1000) // wait for animation finished
      }
    },
    userLanguage (userLanguage) {
      console.log('App:userLanguage:changed', userLanguage)
      this.$i18n.locale = userLanguage
      this.refreshUILang()

      this._handleLanguageChanged()
    }
  }
}
</script>

<style lang="scss" scoped>
#app {
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  background-color: #efebe9 !important; // .brown.lighten-5
}

.step2 {
  @include bg-gradient-orange();
}
</style>



// WEBPACK FOOTER //
// src/App.vue